import { useTheme } from '@mui/material';
import React from 'react';
import { AccountCircle as AccountCircleIcon } from '@mui/icons-material';
import ROProfileStock from './ro-profile-stock.jpeg';
import { isDemo } from 'op-utils';
import { Stack } from '@mui/material';

interface Props {
  image?: HTMLImageElement;
  inHeader?: boolean;
  useStock?: boolean;
}

const ROProfilePhoto = ({ image, inHeader, useStock }: Props): JSX.Element => {
  const theme = useTheme();
  // Use stock image if demo env and set to use stock image (current LHS pane)
  if (useStock && isDemo) {
    return (
      <Stack width={'92px'}>
        <img style={{ borderRadius: '50%' }} src={ROProfileStock} />
      </Stack>
    );
  }

  if (inHeader) {
    return <AccountCircleIcon sx={{ color: theme.palette.primary.contrastText }} />;
  }

  // TODO: Replace empty return with image file when data available
  if (image) {
    return <></>;
  }
  return <AccountCircleIcon sx={{ width: 56, height: 56, color: 'grey.300' }} />;
};

export default ROProfilePhoto;
